import React from "react";
import { Box, Skeleton } from "@mui/material";

const ImageCardSkeleton = () => {
  return (
    <Box
      sx={{
        width: 600,
        background: "#000",
        padding: "12px",
        borderRadius: "12px",
      }}
    >
      {/* Name skeleton */}
      <Skeleton
        variant="text"
        width="50%"
        height={24}
        sx={{ marginBottom: "12px" }}
      />

      {/* Image skeleton */}
      <Skeleton
        variant="rectangular"
        width={600}
        height={600}
        sx={{ borderRadius: "8px" }}
        animation="wave"
      />
    </Box>
  );
};

export default ImageCardSkeleton;
